import classNames from "@casino/external/classNames";
import type { ElementType } from "react";
import getAnimation from "../animation/getAnimation";
import getButtonSize from "../getSize/getButtonSize";
import type Props from "../types/Props";
import getButtonCommonStyles from "./getButtonCommonStyles";
import getButtonVariants from "./getButtonVariants";

const ButtonComponent: FC<Props> = ({
  variant,
  size,
  iconLeft,
  iconRight,
  fullWidth,
  disabled,
  animation,
  as,
  customClassName,
  ...rest
}) => {
  const Component = (as || "button") as ElementType;
  return (
    <Component
      className={classNames(
        getButtonSize({
          size,
          iconLeft,
          iconRight,
          fullWidth,
        }),
        getButtonCommonStyles(disabled),
        getButtonVariants({ variant, disabled }),
        animation === "pulse" && getAnimation("pulse"),
        fullWidth && "w-full",
        customClassName,
      )}
      {...((!as || as === "button") && { type: "button" })}
      {...(disabled && { disabled })}
      {...rest}
    />
  );
};

export default ButtonComponent;
